import React from 'react';
import { useSelector } from 'react-redux';

import { getGiftMessage, getGiftCustomizing, getMessageType } from '../../../store/data/data.selectors';
import ExpanderWrapper from '../../../../../components/Layout/ExpandedWrapper';
import { getRecipientState, getSenderState } from '../../../../../store/users/users.selectors';
import GiftMessageFactory from '../../../../../components/GiftMessage/GiftMessageFactory';

import GiftMessageHeader from './GiftMessageHeader';

const GiftGreetingMessage = (): JSX.Element => {
  const recipient = useSelector(getRecipientState);
  const message = useSelector(getGiftMessage);
  const customizing = useSelector(getGiftCustomizing);
  const messageType = useSelector(getMessageType);
  const sender = useSelector(getSenderState);

  const factoryComponentsParams = {
    message,
    customizing,
    sender,
  };

  const header = !customizing.hideHeaders ? (
    <GiftMessageHeader recipientName={recipient?.firstName} headerText={message.header} />
  ) : undefined;

  return (
    <ExpanderWrapper header={header}>
      <GiftMessageFactory type={messageType} {...factoryComponentsParams} />
    </ExpanderWrapper>
  );
};

export default GiftGreetingMessage;
